import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

document.addEventListener( 'DOMContentLoaded', function() {
  const stickyElements = document.querySelectorAll('.sticky');

  if( stickyElements ) {
    stickyElements.forEach((el)=> {

      const formError = el.querySelector('.gform_validation_error');

      if( ! formError ) {
        ScrollTrigger.matchMedia({
          // makes slider sticky (above 960px only)
          "(min-width: 1160px)": function() {
            ScrollTrigger.create({
              trigger: el,
              start: 'top top+=100px',
              end: 'bottom top+=200px',
              pin: true,
              pinSpacing: false
            });
          }
        });
      }

    });
  }

});